import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IFieldPreferences } from '@app/components/form/services/schema-form/schema-form-interfaces';

@Component({
  selector: 'xvi-xux-transfer-summary',
  templateUrl: './xux-transfer-summary.component.html',
  styleUrls: ['./xux-transfer-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxTransferSummaryComponent implements OnInit {
  @Input() public field: IFieldPreferences = {};

  public constructor() {}

  public ngOnInit() {}
}
